const navData = {
    data: [{
            title: 'HOME',
            href: '#',
        },
        {
            title: 'ABOUT US',
            href: '#',
        },

        {
            title: 'BLOG',
            href: '#',
        },
        {
            title: 'FAQ',
            href: '#',
        },

        {
            title: 'CONTACT US ',
            href: '#',
        },
    ],
};

export default navData;